export default __webpack_public_path__ + "static/media/constriction.45e883a1.png";